/**
 * @desc 预警配置、消息中心部分参数定义
 */

/**
 *  @desc 通知对象人员类型选择下拉框
 */
export const PERSON_SELECT_LIST = [
    {text: '关联人员', id: 'ASSOCIATE_PERSONNEL', disabled: false},
    {text: '指定人员', id: 'SPECIFY_PERSONNEL', disabled: false}
]

/**
 * @desc 通知对象关联人员人员类型选择下拉框
 */
export const RELATION_LIST = [
    {text: '店铺授权', id: 'ASSOCIATE_PERSONNEL_003', disabled: true},
    {text: '平台管理员', id: 'ASSOCIATE_PERSONNEL_001'},
    {text: '销售负责人', id: 'ASSOCIATE_PERSONNEL_002'}
]


export const CONDITION = {
    /**
     *  @desc 小于、小于等于
     */
    LESS_THAN: [
        {text: '小于', id: 'CONDITION_VAL_001'},
        {text: '小于等于', id: 'CONDITION_VAL_002'}
    ],

    /**
     *  @desc 大于、大于等于
     */
    GREATER_THAN: [
        {text: '大于', id: 'CONDITION_VAL_003'},
        {text: '大于等于', id: 'CONDITION_VAL_004'}
    ],

    /**
     * @desc 大于、大于等于、小于、小于等于
     */
    ALL_THAN: [
        {text: '小于', id: 'CONDITION_VAL_001'},
        {text: '小于等于', id: 'CONDITION_VAL_002'},
        {text: '大于', id: 'CONDITION_VAL_003'},
        {text: '大于等于', id: 'CONDITION_VAL_004'}
    ],

    /**
     *  @desc 大于、小于
     */
    GREATER_LESS: [
        {text: '小于', id: 'CONDITION_VAL_001'},
        {text: '大于', id: 'CONDITION_VAL_003'}
    ],

    /**
     * @desc 统计时间（类型）
     */
    STATISTICAL_TIME: [
        {text: '北京时间', id: 'CONDITION_VAL_005'},
        {text: '市场时间', id: 'CONDITION_VAL_006'}
    ],

    /**
     * @desc 星级
     */
    STAR_LIST: [
        {text: '一星', id: '1'},
        {text: '二星', id: '2'},
        {text: '三星', id: '3'},
        {text: '四星', id: '4'},
        {text: '五星', id: '5'},
    ],

    /**
     * @desc 统计时间（周）
     */
    WEEK_LIST: [
        {text: '周一', id: 'CONDITION_VAL_014'},
        {text: '周二', id: 'CONDITION_VAL_015'},
        {text: '周三', id: 'CONDITION_VAL_016'},
        {text: '周四', id: 'CONDITION_VAL_017'},
        {text: '周五', id: 'CONDITION_VAL_018'},
        {text: '周六', id: 'CONDITION_VAL_019'},
        {text: '周日', id: 'CONDITION_VAL_020'},
    ],

    /**
     * @desc 数据形式
     */
    DATA_FORM: [
        {text: '按店铺通知', id: 'CONDITION_VAL_012'},
        {text: '按商品(ASIN)通知', id: 'CONDITION_VAL_013'},
    ],

    /**
     * @desc 比率
     */

    RATIO: [
        {text: '提升', id: 'CONDITION_VAL_021'},
        {text: '降低', id: 'CONDITION_VAL_022'},
    ],

    /**
     * @desc 包含
     */
    CONTAIN: [
        {text: '包含', id: 'CONDITION_VAL_025'},
    ],

    /**
     * @desc 等于
     */
    EQUAL: [
        {text: '等于', id: 'CONDITION_VAL_023'},
    ],

    /**
     * @desc 停售
     */
    HALT_SALES: [
        {text: '停售', id: 'CONDITION_VAL_026'},
        {text: '变更为', id: 'CONDITION_VAL_024'},
    ]
}

/**
 * @desc 预警类型,用于预警配置搜索
 */

export const WARNING_TYPE = [
    {text: '商品预警', id: 'LISTING_WARN'},
    {text: '差评预警', id: 'NEGATIVE_RATINGS_WARN'},
    {text: '数据指标预警', id: 'DATA_INDEX_WARN'},
    {text: '店铺绩效预警', id: 'MARKET_PERFORMANCE_WARN'},
    {text: '订单预警', id: 'ORDER_WARN'},
    // {text: '跟卖预警', id: 'FOLLOW_UP_WARN'},
    // {text: '品牌广告审核通知', id: 'ADS_SB_REVIEW'},
]

/**
 * @desc 预警类型，用于运营消息搜索
 */
export const WARNING_TYPE_ALL = [
    ...WARNING_TYPE,
    {text: '跟卖预警', id: 'FOLLOW_UP_WARN'},
    {text: '品牌广告审核通知', id: 'ADS_SB_REVIEW'},
]

/**
 * @desc 预警标题，用于预警配置搜索
 */

export const WARNING_TITLE = [
    // {text: '跟卖预警', id: 'FOLLOW_UP_WARN_001'},
    // {text: '品牌广告审核通知', id: 'ADS_SB_REVIEW_001'},
    {text: 'FBA库存不足', id: 'LISTING_WARN_001'},
    {text: 'FBA库存滞销', id: 'LISTING_WARN_002'},
    {text: 'Listing被下架、被停售', id: 'LISTING_WARN_003'},
    {text: '星级浮动较大', id: 'LISTING_WARN_004'},
    {text: '总评星数浮动较大', id: 'LISTING_WARN_005'},
    {text: 'Review差评', id: 'NEGATIVE_RATINGS_WARN_001'},
    {text: 'Feedback差评', id: 'NEGATIVE_RATINGS_WARN_002'},
    {text: '周销量暴涨', id: 'DATA_INDEX_WARN_001'},
    {text: '日销量暴涨', id: 'DATA_INDEX_WARN_002'},
    {text: '周销量异常', id: 'DATA_INDEX_WARN_003'},
    {text: '日销量异常', id: 'DATA_INDEX_WARN_004'},
    {text: 'A-Z预警', id: 'MARKET_PERFORMANCE_WARN_001'},
    {text: 'Chargeback预警', id: 'MARKET_PERFORMANCE_WARN_002'},
    {text: 'Return request预警', id: 'MARKET_PERFORMANCE_WARN_003'},
    {text: '客户服务绩效异常预警', id: 'MARKET_PERFORMANCE_WARN_004'},
    {text: '政策合规性异常预警', id: 'MARKET_PERFORMANCE_WARN_005'},
    {text: '配送绩效异常预警', id: 'MARKET_PERFORMANCE_WARN_006'},
    {text: '订单配送费差异预警', id: 'ORDER_WARN_001'},
]

/**
 * @desc 预警标题，用于运营消息搜索
 */

export const MESSAGE_TITLE_ALL = [
    ...WARNING_TITLE,
    {text: '跟卖预警', id: 'FOLLOW_UP_WARN_001'},
    {text: '品牌广告审核通知', id: 'ADS_SB_REVIEW_001'}
]

/**
 * @desc 禁用类型
 */
export const OPERATOR_TYPE = [
    {text: '站内', id: 'MSG_WARN_SWITCH_001'},
    {text: '公众号', id: 'MSG_WARN_SWITCH_002'},
    {text: 'APP', id: 'MSG_WARN_SWITCH_003'},
    {text: '是否开启预警', id: 'MSG_WARN_SWITCH_004'},
]

/**
 * @desc 触发条件各个框确定
 *  optionsType—第二个下拉框数据,twoType—第二个输入框类型，
 *  twoDisabled—第二个输入框是否禁止，threeDisabled—第三个输入框是否禁止，isShow—第三个输入框是否显示
 *  threePlaceholder—第二个输入框文字提示，rules—正则规则,isPercent—是否带百分号
 *  threeType—第三个输入框类型,threeOptionsType—第三个下拉框数据,isTwoShow—是否显示第二个框
 */

const validateValue = (rule, value, callback) => {
    if (Number(value) === 0 || !(/^([1-9]\d*|0)(\.\d{1,2})?$/.test(value))) {
        callback(new Error('所填值必须为正数(小数最多到小数点后两位)'));
    } else {
        callback();
    }
}

// 默认属性
const DEFAULT_ATTRS = {
    optionsType: '',
    threeOptionsType: '',
    twoType: 'default',
    threeType: 'input',
    twoDisabled: false,
    threeDisabled: false,
    isShow: true,
    isTwoShow: true,
    threePlaceholder: '请输入正数',
    rules: [
        {required: true, message: '请输入正数', trigger: ['blur', 'change']},
        {validator: validateValue, trigger: ['blur', 'change']},
    ],
    isPercent: false
}

// 部分不可编辑共用属性
const NO_EDIT = {
    ...DEFAULT_ATTRS, optionsType: 'GREATER_THAN', twoDisabled: true, threeDisabled: true, isPercent: true,
}

// 差评共有属性
const BAD_POST = {
    ...DEFAULT_ATTRS,
    optionsType: 'CONTAIN',
    threeOptionsType: 'STAR_LIST',
    threeType: 'multi-check',
    twoDisabled: true,
    threePlaceholder: '请选择星级',
    rules: [
        {required: true, message: '请选择星级', trigger: ['blur', 'change']}
    ],
}

// 周销量共有属性
const WEEKLY_SALES = {
    // 数据统计时间
    'DATA_INDEX_WARN_CONDITION_001': {
        ...DEFAULT_ATTRS,
        threeOptionsType: 'WEEK_LIST',
        threeType: 'default',
        isTwoShow: false,
        rules: [
            {required: true, message: '请选择数据统计时间', trigger: ['change']}
        ],
    },
    // 销量环比比率
    'DATA_INDEX_WARN_CONDITION_002': {...DEFAULT_ATTRS, optionsType: 'RATIO', twoDisabled: true, isPercent: true},
    //  通知数据形式
    'DATA_INDEX_WARN_CONDITION_003': {
        ...DEFAULT_ATTRS,
        threeOptionsType: 'DATA_FORM',
        isTwoShow: false,
        threeType: 'default',
        rules: [
            {required: true, message: '请选择通知数据形式', trigger: ['change']}
        ],
    }
}

// 日销量共有属性
const DAY_SALES = {
    // 数据统计时间
    'DATA_INDEX_WARN_CONDITION_001': {
        ...DEFAULT_ATTRS,
        threeOptionsType: 'STATISTICAL_TIME',
        isTwoShow: false,
        threeType: 'default',
        rules: [
            {required: true, message: '请选择数据统计时间', trigger: ['change']}
        ],
    },
    // 销售环比比率
    'DATA_INDEX_WARN_CONDITION_002': {...DEFAULT_ATTRS, optionsType: 'RATIO', twoDisabled: true, isPercent: true},
}

// 星级共有属性
const STAR = {
    // 数据统计时间
    time: {
        ...DEFAULT_ATTRS, threeOptionsType: 'STATISTICAL_TIME', isTwoShow: false, threeType: 'default',
        rules: [
            {required: true, message: '请选择数据统计时间', trigger: ['change']}
        ]
    },
    // 星级评分浮动比率
    star: {
        ...DEFAULT_ATTRS, optionsType: 'ALL_THAN', isPercent: true,
        // threePlaceholder: '请输入数值',
        // rules: [
        //     {required: true, message: '请输入正数', trigger: ['blur', 'change']},
        //     // {
        //     //     pattern: /^-?([1-9][0-9]*|0)(\.[0-9]?[0-9])?$/,
        //     //     message: '所填值必须为数值(小数最多到小数点后两位)',
        //     //     trigger: ['blur', 'change']
        //     // }
        // ],
    },
}

export const TRIGGER_CONDITION = {
    // FBA库存不足（FBM不参与）
    'LISTING_WARN_001': {
        //    FBA可售量/七日日均销量
        ...DEFAULT_ATTRS, optionsType: 'LESS_THAN',
        rules: [
            {required: true, message: '请输入天数', trigger: ['blur', 'change']},
            {pattern: /^([1-9][0-9]*)$/, message: '天数必须为正整数', trigger: ['blur', 'change']}
        ],
        threePlaceholder: '请输入天数',
    },
    // FBA库存滞销（FBM不参与）
    'LISTING_WARN_002': {
        ...DEFAULT_ATTRS, optionsType: 'GREATER_THAN', isPercent: true
    },
    // listing被下架、被停售
    'LISTING_WARN_003': {
        ...DEFAULT_ATTRS,
        optionsType: 'HALT_SALES',
        threeOptionsType: 'HALT_SALES',
        threeType: 'default',
        // twoDisabled: true,
        isTwoShow: false,
        threeDisabled: true,
        rules: []
    },
    // 星级浮动较大
    'LISTING_WARN_004': {'LISTING_WARN_CONDITION_003': STAR.time, 'LISTING_WARN_CONDITION_006': STAR.star},
    //总评星数浮动较大LISTING_WARN_005
    'LISTING_WARN_005': {'LISTING_WARN_CONDITION_003': STAR.time, 'LISTING_WARN_CONDITION_004': STAR.star},
    // review差评
    'NEGATIVE_RATINGS_WARN_001': {...BAD_POST},
    // Feedback差评NEGATIVE_RATINGS_WARN_002
    'NEGATIVE_RATINGS_WARN_002': {...BAD_POST},
    // 周销量暴涨
    'DATA_INDEX_WARN_001': {...WEEKLY_SALES},
    // 周销量异常DATA_INDEX_WARN_003
    'DATA_INDEX_WARN_003': {...WEEKLY_SALES},
    // 日销量暴涨
    'DATA_INDEX_WARN_002': {...DAY_SALES},
    // 日销量异常DATA_INDEX_WARN_004
    'DATA_INDEX_WARN_004': {...DAY_SALES},
    // A-Z预警
    'MARKET_PERFORMANCE_WARN_001': {...NO_EDIT},
    // Chargeback预警
    'MARKET_PERFORMANCE_WARN_002': {...NO_EDIT},
    // Return request预警
    'MARKET_PERFORMANCE_WARN_003': {...NO_EDIT},
    // 客户服务绩效异常预警
    'MARKET_PERFORMANCE_WARN_004': {...NO_EDIT},
    // 政策合规性异常预警
    'MARKET_PERFORMANCE_WARN_005': {...NO_EDIT, isPercent: false},
    // 配送绩效异常预警
    'MARKET_PERFORMANCE_WARN_006': {
        ...NO_EDIT, optionsType: 'GREATER_LESS'
    },
    // 订单配送费差异预警
    'ORDER_WARN_001': {...NO_EDIT, threeDisabled: false}
}


// 政策合规性预警字段转换
export const POLICY_COMPLIANCE = {
    intellectualPropertyData: '知识产权投诉',
    productSafetyData: '商品安全投诉',
    productAuthenticityData: '商品真实性投诉',
    listingPolicyData: '上架政策违规',
    conditionBuyerComplaints: '商品状况买家投诉',
    restrictedProductsPolicy: '违反受限商品政策',
    buyerProductReviewPolicy: '违反买家商品评论政策'
}

// 标题转换
export const WARN_TITLE_SWITCH = {
    'LISTING_WARN_001': '库存不足预警',
    'LISTING_WARN_002': 'FBA库存滞销预警',
    'LISTING_WARN_003': 'Listing下架/停售',
    'LISTING_WARN_004': '星级评分异常预警',
    'LISTING_WARN_005': '评星数异常预警',
    'NEGATIVE_RATINGS_WARN_001': 'Review预警',
    'NEGATIVE_RATINGS_WARN_002': 'Feedback预警',
    'DATA_INDEX_WARN_001': '周销量暴涨',
    'DATA_INDEX_WARN_002': '日销量暴涨',
    'DATA_INDEX_WARN_003': '周销量异常',
    'DATA_INDEX_WARN_004': '日销量异常',
    'MARKET_PERFORMANCE_WARN_001': 'A-Z预警',
    'MARKET_PERFORMANCE_WARN_002': 'Chargeback预警',
    'MARKET_PERFORMANCE_WARN_003': 'Return request预警',
    'MARKET_PERFORMANCE_WARN_004': '服务绩效预警',
    'MARKET_PERFORMANCE_WARN_005': '政策合规性预警',
    'MARKET_PERFORMANCE_WARN_006': '配送绩效预警',
    'ORDER_WARN_001': '配送费异常预警',
    'FOLLOW_UP_WARN_001': '跟卖预警',
    'ADS_SB_REVIEW_001': '品牌广告审核通知'
}

const handlerValue = (str) => {
    if (!str && parseInt(str) !== 0) {
        return '-';
    }
    return str;
}

export const WARN_CHANGE_TITLE = (message) => {
    let returnStr = '';
    const content = message.warnContent;
    switch (message.warnTitleCode) {
        // 库存不足预警
        case 'LISTING_WARN_001':
            return returnStr = `${handlerValue(message.markName)} 图片、ASIN：${handlerValue(content.asin)}、MSKU：${handlerValue(content.msku)}、FNSKU：${handlerValue(content.fnsku)}，FBA库存可售天数不足${handlerValue(content.fulfillableDay)}天；可售量：${handlerValue(content.fulfillableQuantity)}；可用量：${handlerValue(content.useQuantity)}；待出运量：${handlerValue(content.waitShipmentQuantity)}；在途量：${handlerValue(content.onWayQuantity)}；计划入库量：${handlerValue(content.workingQuantity)}；预留：${handlerValue(content.reservedQuantity)}；`
        // FBA库存滞销预警
        case 'LISTING_WARN_002':
            return returnStr = `${handlerValue(message.markName)} 图片、ASIN：${handlerValue(content.asin)}、MSKU：${handlerValue(content.msku)}、滞销率：${handlerValue(content.slowsalesRate)}%、FBA库存量：${handlerValue(content.fbaStock)}、滞销量：${handlerValue(content.slowSales)}。`
        // listing下架/停售
        case 'LISTING_WARN_003':
            return returnStr = `${handlerValue(message.markName)} 图片、MSKU：${handlerValue(content.msku)}、 ASIN：${handlerValue(content.asin)}、预警内容：${handlerValue(content.warnContent)}`
        // 星级浮动较大
        case 'LISTING_WARN_004':
            return returnStr = `${handlerValue(message.markName)} 图片、MSKU：${handlerValue(content.msku)}、ASIN：${handlerValue(content.asin)}，星级评分数据异常；${handlerValue(content.yesterdayDate)}，星级评分${handlerValue(content.yesterdayStar)}；${handlerValue(content.todayDate)}，星级评分${handlerValue(content.todayStar)}；`
        // 总评星数浮动较大
        case 'LISTING_WARN_005':
            return returnStr = `${handlerValue(message.markName)} 图片、MSKU：${handlerValue(content.msku)}、ASIN：${handlerValue(content.asin)}，总评星数数据异常；${handlerValue(content.yesterdayDate)}，总评星数${handlerValue(content.yesterdayTotalStar)}；${handlerValue(content.todayDate)}，总评星数${handlerValue(content.todayTotalStar)}；`
        // review差评
        case 'NEGATIVE_RATINGS_WARN_001':
            return returnStr = `【${handlerValue(content.countryCode)}】 图片、MSKU：${handlerValue(content.reviewList[0].msku)}、ASIN：${handlerValue(content.reviewList[0].asin)}，review ID：${handlerValue(content.reviewId)}；留评用户：${handlerValue(content.reviewUser)}；是否VP：${content.hasVP === 1 ? '是' : '否'}；评论标题：${handlerValue(content.reviewList[0].title)}；评论内容：${handlerValue(content.reviewContent)}；评论时间：${handlerValue(content.reviewTime)}`
        // Feedback差评
        case 'NEGATIVE_RATINGS_WARN_002':
            return returnStr = `${handlerValue(message.markName)} 图片、MSKU：${handlerValue(content.reviewList[0].msku)}、ASIN：${handlerValue(content.reviewList[0].asin)}，feedback ID：${handlerValue(content.feedbackId)}；订单编号：${handlerValue(content.orderId)}；评论内容：${handlerValue(content.reviewContent)} ；评论时间：${handlerValue(content.reviewTime)}`
        //  周销量暴涨
        case 'DATA_INDEX_WARN_001':
            if (content.warnDimension === 'market') {
                return returnStr = `${handlerValue(message.markName)} 预警商品数量：${handlerValue(content.warnQuantity)}个；整体销量暴涨${handlerValue(content.overAllRise)}%；${handlerValue(content.saleLastWeekDay)}，销量：${handlerValue(content.saleLastWeek)}；${handlerValue(content.salesWeekDay)}，销量：${handlerValue(content.salesWeek)}；`
            }
            return returnStr = `${handlerValue(message.markName)} 图片、MSKU：${handlerValue(content.msku)}、 ASIN：${handlerValue(content.asin)}，销量暴涨${handlerValue(content.overAllRise)}%；${handlerValue(content.saleLastWeekDay)}，销量：${handlerValue(content.saleLastWeek)}；${handlerValue(content.salesWeekDay)}，销量：${handlerValue(content.salesWeek)}；`
        // 日销量暴涨
        case 'DATA_INDEX_WARN_002':
            return returnStr = `${handlerValue(message.markName)} 图片、MSKU：${handlerValue(content.msku)}、 ASIN：${handlerValue(content.asin)}，销量暴涨${handlerValue(content.rise)}%；${handlerValue(content.yesterday)}，销量：${handlerValue(content.yesterdaySaleQuantity)}；${handlerValue(content.today)}，销量：${handlerValue(content.todaySaleQuantity)}；`
        // 周销量异常
        case 'DATA_INDEX_WARN_003':
            if (content.warnDimension === 'market') {
                return returnStr = `${handlerValue(message.markName)} 预警商品数量：${handlerValue(content.warnQuantity)}个；整体销量下跌${handlerValue(content.overAllFall)}%；${handlerValue(content.saleLastWeekDay)}，销量：${handlerValue(content.saleLastWeek)}；${handlerValue(content.salesWeekDay)}，销量：${handlerValue(content.salesWeek)}；`
            }
            return returnStr = `${handlerValue(message.markName)} 图片、MSKU：${handlerValue(content.msku)}、 ASIN：${handlerValue(content.asin)}，销量下跌${handlerValue(content.overAllFall)}%；${handlerValue(content.saleLastWeekDay)}，销量：${handlerValue(content.saleLastWeek)}；${handlerValue(content.salesWeekDay)}，销量：${handlerValue(content.salesWeek)}；`
        // 日销量异常
        case 'DATA_INDEX_WARN_004':
            return returnStr = `${handlerValue(message.markName)} 图片、MSKU：${handlerValue(content.msku)}、 ASIN：${handlerValue(content.asin)}，销量下跌${handlerValue(content.fall)}%；${handlerValue(content.yesterday)}，销量：${handlerValue(content.yesterdaySaleQuantity)}；${handlerValue(content.today)}，销量：${handlerValue(content.todaySaleQuantity)}；`
        // A-Z预警
        case 'MARKET_PERFORMANCE_WARN_001':
            return returnStr = `${handlerValue(message.markName)} ${handlerValue(message.createTime)} A-Z异常预警；订单数：${handlerValue(content.azClaimsTime)}；订单缺陷百分比：${handlerValue(content.azClaims)}%；`
        // Chargeback预警
        case 'MARKET_PERFORMANCE_WARN_002':
            return returnStr = `${handlerValue(message.markName)} ${handlerValue(message.createTime)} 绩效Chargeback异常；订单数：${handlerValue(content.chargebackTime)}；信用卡拒付索赔＞${handlerValue(content.chargeback)}%；`
        // Return request预警
        case 'MARKET_PERFORMANCE_WARN_003':
            return returnStr = `${handlerValue(message.markName)} ${handlerValue(message.createTime)} 绩效Return request异常；负面反馈＞${handlerValue(content.negativeFeedBacks)}%；`
        // 客户服务绩效异常预警
        case 'MARKET_PERFORMANCE_WARN_004':
            return returnStr = `${handlerValue(message.markName)} ${handlerValue(message.createTime)} 客户服务绩效异常预警；订单缺陷率＞${handlerValue(content.orderWithDefects)}%；负面反馈＞${handlerValue(content.negativeFeedBacks)}%，${handlerValue(content.negativeFeedBacksTime)}次；A-Z＞${handlerValue(content.azClaims)}%，${handlerValue(content.azClaimsTime)}次；chargeback＞${handlerValue(content.chargeback)}%，${handlerValue(content.chargebackTime)}次；退货不满意率＞${handlerValue(content.returnDissatisfaction)}；负面回复＞${handlerValue(content.negativeReturnFeedback)}%，${handlerValue(content.negativeReturnFeedbackTime)}次；延迟回复＞${handlerValue(content.lateResponse)}%，${handlerValue(content.lateResponseTime)}次；无效拒绝＞${handlerValue(content.invalidRejection)}%，${handlerValue(content.invalidRejectionTime)}次`
        // 政策合规性异常预警
        case 'MARKET_PERFORMANCE_WARN_005':
            return returnStr = `${handlerValue(message.markName)} ${handlerValue(message.createTime)} 政策合规性预警；知识产权投诉：${handlerValue(content.intellectualPropertyData)}次；商品安全投诉：${handlerValue(content.productSafetyData)}次；商品真实性投诉：${handlerValue(content.productAuthenticityData)}次；上架政策违规：${handlerValue(content.listingPolicyData)}次；商品状况买家投诉：${handlerValue(content.conditionBuyerComplaints)}次；违反受限商品政策：${handlerValue(content.restrictedProductsPolicy)}次；违反买家商品评论政策：${handlerValue(content.buyerProductReviewPolicy)}次 `
        // 配送绩效异常预警
        case 'MARKET_PERFORMANCE_WARN_006':
            return returnStr = `${handlerValue(message.markName)} ${handlerValue(message.createTime)} 配送绩效异常预警；迟发率＞${handlerValue(content.lateShipment)}%，订单数：${handlerValue(content.lateShipmentOrder)}；预配送取消率＞${handlerValue(content.preFulfillmentCancellation)}%，订单数：${handlerValue(content.preFulfillmentCancellationOrder)}；有效追踪率＜${handlerValue(content.validTracking)}%，订单数：${handlerValue(content.validTrackingOrder)}；准时交货率＜${handlerValue(content.onTimeDelivery)}%，订单数：${handlerValue(content.onTimeDeliveryOrder)}；`
        // 订单配送费差异预警
        case 'ORDER_WARN_001':
            return returnStr = `${handlerValue(message.markName)} ${handlerValue(message.createTime)} 订单配送费异常预警；订单编号一：${handlerValue(content.orderList[0].orderId)}；订单订购时间：${handlerValue(content.orderList[0].purchaseDate)}；图片、ASIN：${handlerValue(content.orderList[0].asin)}；FBA配送费：${handlerValue(content.currency)}${handlerValue(content.orderList[0].fbaFees)}；订单编号二：${handlerValue(handlerValue(content.orderList[1].orderId))}；订单订购时间：${handlerValue(handlerValue(content.orderList[1].purchaseDate))}；图片、ASIN：${handlerValue(content.orderList[1].asin)}；FBA配送费：${handlerValue(content.currency)}${handlerValue(content.orderList[1].fbaFees)}`
        // case 'ADS_SB_REVIEW_001':
        //     return returnStr = content.warnContent;
    }

}
